import { vaultGetRequest } from '../helpers';
import type { IVaultSystemResponse } from './fetch-system-response';
import { vaultSystemResponseSchema } from './fetch-system-response';

export async function fetchSystemApi(): Promise<IVaultSystemResponse> {
  return vaultGetRequest({ path: '/system', schema: vaultSystemResponseSchema });
}
